import {API_ACTION, API_SKILL, API_SKILL_QUESTIONS} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getByCategory = async (practice, period, category) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_SKILL_QUESTIONS}/${practice}/${period}/${category}`,
    });

    return res.data;
  } catch (error) {
    console.error('getByCategory Error:', error.message);
    return null;
  }
};

const updateBatch = async (questions) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL + API_ACTION.UPDATE + API_ACTION.BATCH,
      data: questions,
    });
    return res.data;
  } catch (error) {
    console.error('updateBatch Error:', error.message);
    return null;
  }
};

const modify = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL + API_ACTION.MODIFY,
      data: data,
    });
    return res.data;
  } catch (error) {
    console.error('Modify Error:', error.message);
    return null;
  }
};

const deleteSkill = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL + API_ACTION.DELETE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('Delete Error:', error.message);
    return null;
  }
};

const skillApi = {
  getByCategory,
  updateBatch,
  modify,
  deleteSkill,
};

export default skillApi;
